import React from 'react';
import { CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';

interface HealthStatusBadgeProps {
  status: 'ok' | 'warning' | 'degraded' | 'severe' | 'updating';
  message: string;
  lastChecked?: Date;
}

const HealthStatusBadge: React.FC<HealthStatusBadgeProps> = ({
  status,
  message,
}) => {
  const statusConfig = {
    ok: {
      icon: <CheckCircleOutlined className="text-xl" />,
      label: 'Healthy',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      textColor: 'text-green-800',
      iconColor: 'text-green-600',
    },
    warning: {
      icon: <ExclamationCircleOutlined className="text-xl" />,
      label: 'Warning',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-600',
    },
    degraded: {
      icon: <CloseCircleOutlined className="text-xl" />,
      label: 'Degraded',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      textColor: 'text-red-800',
      iconColor: 'text-red-600',
    },
    severe: {
      icon: <CloseCircleOutlined className="text-xl" />,
      label: 'Severe',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      textColor: 'text-red-800',
      iconColor: 'text-red-600',
    },
    updating: {
      icon: <SyncOutlined spin className="text-xl" />,
      label: 'Updating',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      textColor: 'text-blue-800',
      iconColor: 'text-blue-600',
    },
  };

  const config = statusConfig[status];

  return (
    <div className={`bg-white dark:bg-gray-800 border ${config.borderColor} rounded-lg overflow-hidden`}>
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Environment Health</h3>
      </div>
      <div className={`${config.bgColor} px-6 py-4`}>
        <div className="flex items-center gap-3">
          <div className={config.iconColor}>
            {config.icon}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className={`text-sm font-semibold ${config.textColor}`}>
                {config.label}
              </span>
            </div>
            <p className={`text-sm ${config.textColor}`}>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthStatusBadge;